import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { RouterModule, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as D3 from "d3";

import * as _moment from 'moment';

import {defaultFormat as _rollupMoment} from 'moment';
import { IData } from 'src/app/models/data.interface';
import { element } from '@angular/core/src/render3';
import { User } from 'src/app/models/user';
import { dashboardApprover, dashboardRequestor } from 'src/app/modules/shared/common/api';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
  selector: 'ark-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class DashboardComponent implements AfterViewInit {
  
  //Approver
  @ViewChild("travelAuthorizationChart") elementAuthorization: ElementRef;
  @ViewChild("cashAdvanceChart") elementCashAdvance: ElementRef;
  @ViewChild("liquidationChart") elementLiquidation: ElementRef;
  @ViewChild("reimbursementChart") elementReimbursement: ElementRef;

  //Requestor
  @ViewChild("travelRequestor") elementAuthorizationRequestor: ElementRef;
  @ViewChild("cashRequestor") elementCashAdvanceRequestor: ElementRef;
  @ViewChild("liquidationRequestor") elementLiquidationRequestor: ElementRef;
  @ViewChild("reimbursementRequestor") elementReimbursementRequestor: ElementRef;

  //Empty Chart
  @ViewChild("emptyChart") emptyPieChart: ElementRef;

  private host: D3.Selection<any>;
  private svg: D3.Selection<any>;
  private width: number;
  private height: number;
  private radius: number;
  private htmlElement: HTMLElement;
  private pieData: IData[];
  isRole:boolean = false; 
  user = new User();
  data = [];
  valuefilter: String = '';
  ifempty:boolean = false;
  overdue: number = 0;

  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private renderer: Renderer2
  ) { 
    this.isRole = this.user.getRole();
  }

  ngAfterViewInit() {
    if (this.isRole) {

      this.htmlElement = this.elementAuthorization.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [1];
      this.buildPie();

      // this.htmlElement = this.elementCashAdvance.nativeElement;
      // this.host = D3.select(this.htmlElement);
      // this.data = [1];
      // this.buildPie();
          
      this.htmlElement = this.elementLiquidation.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [1];
      this.buildPie();

      this.htmlElement = this.elementReimbursement.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [1];
      this.buildPie();


      this.dashboardService.url = dashboardApprover;
      this.dashboardService.getFilter().subscribe(data => {
        this.htmlElement = this.elementAuthorization.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.travel_authorization.no_of_approved_request,
          data.travel_authorization.no_of_pending_approval,
          data.travel_authorization.no_of_push_back_request,
          data.travel_authorization.no_of_rejected_request
        ];
        
        this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ; 
        if (this.data.reduce(this.totalArr,0) == 0) {
          // this.renderer.setStyle(this.elementAuthorization.nativeElement, 'display', 'none');
        }
        this.buildPie('approver',0);
    
        // this.htmlElement = this.elementCashAdvance.nativeElement;
        // this.host = D3.select(this.htmlElement);
        // this.data = [
        //   data.cash_advance.no_of_approved_request,
        //   data.cash_advance.no_of_pending_approval,
        //   data.cash_advance.no_of_push_back_request,
        //   data.cash_advance.no_of_rejected_request
        // ];
        // this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ;
        // if (this.data.reduce(this.totalArr,0) == 0) {
        //   this.renderer.setStyle(this.elementCashAdvance.nativeElement, 'display', 'none');
        // }
        // this.buildPie('approver',1);
    
        this.htmlElement = this.elementLiquidation.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.liquidation.no_of_approved_request,
          data.liquidation.no_of_pending_approval,
          data.liquidation.no_of_push_back_request,
          data.liquidation.no_of_rejected_request
        ];
        this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ;
        if (this.data.reduce(this.totalArr,0) == 0) {
          // this.renderer.setStyle(this.elementLiquidation.nativeElement, 'display', 'none');
        }
        this.buildPie('approver',2);

        this.htmlElement = this.elementReimbursement.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.reimbursement.no_of_approved_request,
          data.reimbursement.no_of_pending_approval,
          data.reimbursement.no_of_push_back_request,
          data.reimbursement.no_of_rejected_request
        ];
        this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ;
        if (this.data.reduce(this.totalArr,0) == 0) {
          // this.renderer.setStyle(this.elementReimbursement.nativeElement, 'display', 'none');
        }
        this.buildPie('approver',3);

      });

    }

    this.htmlElement = this.elementAuthorizationRequestor.nativeElement;
    this.host = D3.select(this.htmlElement);
    this.data = [1];
    this.buildPie();

    // this.htmlElement = this.elementCashAdvanceRequestor.nativeElement;
    // this.host = D3.select(this.htmlElement);
    // this.data = [1];
    // this.buildPie();

    this.htmlElement = this.elementLiquidationRequestor.nativeElement;
    this.host = D3.select(this.htmlElement);
    this.data = [1];
    this.buildPie();
    
    this.htmlElement = this.elementReimbursementRequestor.nativeElement;
    this.host = D3.select(this.htmlElement);
    this.data = [1];
    this.buildPie();


    this.dashboardService.url = dashboardRequestor;
    this.dashboardService.getFilter().subscribe(data => {
      this.htmlElement = this.elementAuthorizationRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.travel_authorization.no_of_approved_request,
        data.travel_authorization.no_of_pending_approval,
        data.travel_authorization.no_of_push_back_request,
        data.travel_authorization.no_of_rejected_request
      ];
      this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ; 
      this.buildPie('requestor',0);


      // this.htmlElement = this.elementCashAdvanceRequestor.nativeElement;
      // this.host = D3.select(this.htmlElement);
      // this.data = [
      //   data.cash_advance.no_of_approved_request,
      //   data.cash_advance.no_of_pending_approval,
      //   data.cash_advance.no_of_push_back_request,
      //   data.cash_advance.no_of_rejected_request
      // ];
      // this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ;
      // if (this.data.reduce(this.totalArr,0) == 0) {
      //   this.renderer.setStyle(this.elementCashAdvanceRequestor.nativeElement, 'display', 'none');
      // }
      // this.buildPie('requestor',1);

      this.htmlElement = this.elementLiquidationRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.liquidation.no_of_approved_request,
        data.liquidation.no_of_pending_approval,
        data.liquidation.no_of_push_back_request,
        data.liquidation.no_of_rejected_request
      ];
      this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ; 
      if (this.data.reduce(this.totalArr,0) == 0) {
        // this.renderer.setStyle(this.elementLiquidationRequestor.nativeElement, 'display', 'none');
      }
      this.buildPie('requestor',2);

      this.htmlElement = this.elementReimbursementRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.reimbursement.no_of_approved_request,
        data.reimbursement.no_of_pending_approval,
        data.reimbursement.no_of_push_back_request,
        data.reimbursement.no_of_rejected_request
      ];
      this.data = (this.data.reduce(this.totalArr,0) == 0)? [1] : this.data ;
      if (this.data.reduce(this.totalArr,0) == 0) {
        // this.renderer.setStyle(this.elementReimbursementRequestor.nativeElement, 'display', 'none');
      }
      this.buildPie('requestor',3);
      this.overdue = data.overdue;
    });

  }
  /**
   * Create Pie Chart D3
   * @param role approver || requestor
   * @param type 0 = authorization ,1 = cash advance, 2 = liquidation, 3 = reimbursement
   */
  private buildPie(role?:String,type?:Number,travel_type?:String): void {
    var self = this;
    this.width = 250;
    this.height = 250;
    this.radius = Math.min(this.width, this.height) / 2;
    this.host.html("");
    let innerRadius = this.radius - 50;
    let outerRadius = this.radius - 10;
    
    this.svg = this.host.append("svg")
        .attr("viewBox", `0 0 ${this.width} ${this.height}`)
        .data([this.pieData])
        .attr('width', this.width)
        .attr('height', this.height)
        .append("g")
        .attr("transform", `translate(${this.width / 2},${this.height / 2})`);

    // let pie = D3.pie().value((function(d) { return d})(this.pieData));
    let pie = D3.pie().value((function(d) { return d}));

    let path = D3.arc().outerRadius( this.radius - 10).innerRadius(0);
    let label = D3.arc().outerRadius(this.radius - 40).innerRadius( this.radius - 40);
    
    let values = this.data;
    let pieColor = D3.scaleOrdinal(["#9b59b6","#f9c80e","#3498DB","#E74C3C"]);
    if (this.data.length == 1) {
      pieColor = D3.scaleOrdinal(["#f2f2f2"]);
      values = [1];
      this.data = [''];
    }

    let arc = this.svg.selectAll('.arc')
        .data(pie(values))
        .enter()
        .append('g')
        .attr('class', 'arc');

    /**
     * case 0 = Approved
     * case 1 = Pending
     * case 2 = Push Back
     * case 3 = Reject
     */
 
    arc.append('path')
        .attr('d', path)
        .attr('class', 'pointer-mouse pie-'+type+' '+role)
        .attr('fill', function (d, i) {
            return pieColor(i);
        }).on("click", function(d,i){
            var status= ["Approved","Pending Approval","Pushed Back","Rejected"];
            var route = 
              {
                'approver':{
                  0:['travel-request-approver'],
                  1:['travel-cash-approver'],
                  2:['liquidation-approver'],
                  3:['reimbursement-approver']
                },
                'requestor': {
                  0:['travel-request'],
                  1:['travel-cash-advance'],
                  2:['liquidation'],
                  3:['reimbursement']
                }

            };

            var classN = D3.select(this).attr('class').split(" ");
            switch (classN[1]) {
              case 'pie-0':
                self.router.navigateByUrl(route[classN[2]][0]+"?status="+status[i]+"&dashboard=true"+"&travel_type="+travel_type+"&travel_request_type=Cash Advance");
                break;
              case 'pie-1':
                self.router.navigateByUrl(route[classN[2]][1]+"?status="+status[i]+"&dashboard=true"+"&travel_type="+travel_type+"&travel_request_type=Cash Advance");
                break;
              case 'pie-2':
              var status= ["Closed","Pending Approval","For Further Review","Rejected"];
                self.router.navigateByUrl(route[classN[2]][2]+"?status="+status[i]+"&dashboard=true"+"&travel_type="+travel_type+"&travel_request_type=Cash Advance");
                break;
              case 'pie-3':
                var status= ["Closed","Pending Approval","Pushed Back","Rejected"];
                self.router.navigateByUrl(route[classN[2]][3]+"?status="+status[i]+"&dashboard=true"+"&travel_type="+travel_type+"&travel_request_type=Cash Advance");
                break;    
              default:
                break;
            }

        });

    arc.append("text")
        .attr("transform", (datum: any) => {
            datum.innerRadius = 0;
            datum.outerRadius = this.radius;
            return "translate(" + label.centroid(datum) + ")";
        })
        .text((datum, index) => (this.data[index] || ''))
        .style("fill",'#ffff')
        .style("text-anchor", "middle");

  }

  setFilter(e:String,type:String) {
    this.valuefilter = e;
    if (this.isRole) {
      type = 'approver';
      this.dashboardService.url = dashboardApprover+'?travel_type='+e;
      this.dashboardService.getFilter().subscribe(data => {
        this.htmlElement = this.elementAuthorization.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.travel_authorization.no_of_approved_request,
          data.travel_authorization.no_of_pending_approval,
          data.travel_authorization.no_of_push_back_request,
          data.travel_authorization.no_of_rejected_request
        ];
        if (this.data.reduce(this.totalArr,0) == 0) {
          this.data = [1];
          // this.renderer.setStyle(this.elementAuthorization.nativeElement, 'display', 'none');
        }
        this.buildPie(type,0, this.valuefilter);

    
        // this.htmlElement = this.elementCashAdvance.nativeElement;
        // this.host = D3.select(this.htmlElement);
        // this.data = [
        //   data.cash_advance.no_of_approved_request,
        //   data.cash_advance.no_of_pending_approval,
        //   data.cash_advance.no_of_push_back_request,
        //   data.cash_advance.no_of_rejected_request
        // ];
        // if (this.data.reduce(this.totalArr,0) == 0) {
        //   this.renderer.setStyle(this.elementCashAdvance.nativeElement, 'display', 'none');
        // }
        // this.buildPie(type,1);

        this.htmlElement = this.elementLiquidation.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.liquidation.no_of_approved_request,
          data.liquidation.no_of_pending_approval,
          data.liquidation.no_of_push_back_request,
          data.liquidation.no_of_rejected_request
        ];
        if (this.data.reduce(this.totalArr,0) == 0) {
          this.data = [1];
          // this.renderer.setStyle(this.elementLiquidation.nativeElement, 'display', 'none');
        }   
        this.buildPie(type,2, this.valuefilter);

        this.htmlElement = this.elementReimbursement.nativeElement;
        this.host = D3.select(this.htmlElement);
        this.data = [
          data.reimbursement.no_of_approved_request,
          data.reimbursement.no_of_pending_approval,
          data.reimbursement.no_of_push_back_request,
          data.reimbursement.no_of_rejected_request
        ];
        if (this.data.reduce(this.totalArr,0) == 0) {
          this.data = [1];
          // this.renderer.setStyle(this.elementReimbursement.nativeElement, 'display', 'none');
        } 
        this.buildPie(type,3, this.valuefilter);

      });
    }

    type = 'requestor';
    this.dashboardService.url = dashboardRequestor+'?travel_type='+e;
    this.dashboardService.getFilter().subscribe(data => {
      this.htmlElement = this.elementAuthorizationRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.travel_authorization.no_of_approved_request,
        data.travel_authorization.no_of_pending_approval,
        data.travel_authorization.no_of_push_back_request,
        data.travel_authorization.no_of_rejected_request
      ];

      if (this.data.reduce(this.totalArr,0) == 0) {
        this.data = [1];
        // this.renderer.setStyle(this.elementAuthorizationRequestor.nativeElement, 'display', 'none');
      } 
      this.buildPie(type,0, this.valuefilter)

      // this.htmlElement = this.elementCashAdvanceRequestor.nativeElement;
      // this.host = D3.select(this.htmlElement);
      // this.data = [
      //   data.cash_advance.no_of_approved_request,
      //   data.cash_advance.no_of_pending_approval,
      //   data.cash_advance.no_of_push_back_request,
      //   data.cash_advance.no_of_rejected_request
      // ];
      // if (this.data.reduce(this.totalArr,0) == 0) {
      //   this.renderer.setStyle(this.elementCashAdvanceRequestor.nativeElement, 'display', 'none');
      // }
      // this.buildPie(type,1);

      this.htmlElement = this.elementLiquidationRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.liquidation.no_of_approved_request,
        data.liquidation.no_of_pending_approval,
        data.liquidation.no_of_push_back_request,
        data.liquidation.no_of_rejected_request
      ]; 
      if (this.data.reduce(this.totalArr,0) == 0) {
        this.data = [1];
        // this.renderer.setStyle(this.elementLiquidationRequestor.nativeElement, 'display', 'none');
      }
      this.buildPie(type,2, this.valuefilter);
      
      this.htmlElement = this.elementReimbursementRequestor.nativeElement;
      this.host = D3.select(this.htmlElement);
      this.data = [
        data.reimbursement.no_of_approved_request,
        data.reimbursement.no_of_pending_approval,
        data.reimbursement.no_of_push_back_request,
        data.reimbursement.no_of_rejected_request
      ];
      if (this.data.reduce(this.totalArr,0) == 0) {
        this.data = [1];
        // this.renderer.setStyle(this.elementReimbursementRequestor.nativeElement, 'display', 'none');
      }
      this.buildPie(type,3, this.valuefilter);
    
    });
  }

  totalArr(a,b) {
    return a+b;
  }

}
